var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.976;fill-rule:evenodd;clip-rule:evenodd;fill:#414141;enable-background:new    ;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#BEC6C6;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FF9800;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#F6F7F9;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#F5F5F9;}\r\n\t.st6{display:none;}\r\n\t.st7{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#F7F8F8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,9.5c81.7-0.2,163.3,0,245,0.5c21.2,3.8,33.7,16.3,37.5,37.5c0.7,138.7,0.7,277.3,0,416 c-3.8,21.2-16.3,33.7-37.5,37.5c-81.7,0.7-163.3,0.7-245,0c-20.3-3.6-32.8-15.4-37.5-35.5c-0.5-9.3-0.5-378.4,1-425 C102.9,23,115,12.7,133.1,9.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.2,31.5c82-0.2,164,0,246,0.5c7.8,2.5,13,7.7,15.5,15.5c0.7,138.7,0.7,277.3,0,416 c-2.5,7.8-7.7,13-15.5,15.5c-81.7,0.7-163.3,0.7-245,0c-7.8-2.5-13-7.7-15.5-15.5c-0.7-139-0.7-278,0-417 C120.7,39.7,125.5,34.7,132.2,31.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.7,52.7c21,0,42,0,63,0c0,134.7,0,269.3,0,404c-78,0-156,0-234,0c0-135,0-270,0-405c21.3,0,42.7,0,64,0 c0.5,9.7,5.2,16.5,14,20.5c12.8,1.1,25.6,1.6,38.5,1.5c11.8-0.2,23.7-0.3,35.5-0.5C301.7,70.7,308,63.9,309.7,52.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.4,159.5c7.4-0.9,13.6,1.4,18.5,7c19.7,39.3,39.3,78.7,59,118c3.3,9.9,0.4,17.4-8.5,22.5 c-42.6,1.6-85.3,2-128,1c-9.4-4.6-12.9-12.1-10.5-22.5c19.7-39.3,39.3-78.7,59-118C243.8,163.8,247.3,161.1,251.4,159.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.2,202.5c6.7-1.2,11.5,1.1,14.5,7c0.7,12.7,0.7,25.3,0,38c-3,7.2-8.2,9.4-15.5,6.5 c-2.2-1.2-3.7-3.1-4.5-5.5c-0.7-13.3-0.7-26.7,0-40C247,206,248.9,204,251.2,202.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251.5,266.5c10.2-1.3,15,3,14.5,13c-2.3,6.4-6.8,8.9-13.5,7.5c-6.1-3-8.2-7.8-6.5-14.5 C247.3,270,249.2,268,251.5,266.5z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.5,372.5c24-0.2,48,0,72,0.5c15.3,5,20.4,15.1,15.5,30.5c-3.4,6.1-8.6,10-15.5,11.5c-25.4,1-50.7,0.6-76-1 c-14.1-8.9-16.6-20.4-7.5-34.5C211.5,376.5,215.3,374.2,219.5,372.5z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M310,53.6c21,0,42,0,63,0c0,134.7,0,269.3,0,404c-78,0-156,0-234,0c0-135,0-270,0-405c21.3,0,42.7,0,64,0 c0.5,9.7,5.2,16.5,14,20.5c12.8,1.1,25.6,1.6,38.5,1.5c11.8-0.2,23.7-0.3,35.5-0.5C302,71.6,308.4,64.8,310,53.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWarning);
export default __webpack_public_path__ + "static/media/mobile-warning.f4efdc34.svg";
export { ForwardRef as ReactComponent };